<template>
    <div class="overlay">
      <div class="login-box">
        <h2>Login</h2>
        <input v-model="username" placeholder="Username" />
        <input v-model="password" type="password" placeholder="Password" />
        <button @click="login" class="btn btn-primary">Enter</button>
        <p v-if="error" class="error">Invalid credentials</p>
      </div>
    </div>
  </template>
  
  <script>
  import CryptoJS from 'crypto-js';
  
  export default {
    data() {
      return {
        username: '',
        password: '',
        error: false
      };
    },
    methods: {
      login() {
        const inputHash = CryptoJS.SHA256(this.username + this.password).toString();
        const validHash = '094d3931e1a1670c8e493c306a00ec9963c0e611bbab310994495cd65b7e5aec'
  
        if (inputHash === validHash) {
          this.$emit('authorized');
          localStorage.setItem('authorized', 'true');
        } else {
          this.error = true;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .overlay {
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    backdrop-filter: blur(10px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  .login-box {
    background: white;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 0 20px rgba(0,0,0,0.2);
  }
  input {
    display: block;
    width: 100%;
    margin: 0.5rem 0;
  }
  .error {
    color: red;
  }
  </style>
  